export const FORM_TYPES = {
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  SIGN_IN: 'SIGN_IN',
  SIGN_UP: 'SIGN_UP',
}
